export default __webpack_public_path__ + "static/media/get-started-icon.504c2a74.svg";